/* import __COLOCATED_TEMPLATE__ from './event-icon.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconSet } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    icon: any; // Use any for icon to match ic-interface-icon's flexible type system
    set?: InterfaceIconSet;
    isEnabled?: boolean; // Deprecated: Icon always renders now, parameter kept for backward compatibility while merging ff removals
  };
  Element: HTMLSpanElement;
}

const EventIcon = templateOnlyComponent<Signature>();
export default EventIcon;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::EventIcon': typeof EventIcon;
    'inbox2/conversation-stream/event-parts/event-icon': typeof EventIcon;
  }
}
